// extracted by mini-css-extract-plugin
module.exports = {"container":"Accent1Button_container__3clbU","label":"Accent1Button_label__s216i"};